import React from "react";
import { ArrowRight } from "lucide-react";
import type { StartClipping } from "./HeroSection";
import { FAQSection } from "./FAQSection";

interface ChatFAQSectionProps {
  onStartClipping: StartClipping;
}

const questions = [
  {
    question: "How much can I actually make?",
    answer:
      "Clippers have pulled in over 100 billion organic views, earning over $100,000,000+ from their clips. It's easy to get started, just paste in a YouTube link and we'll provide you with engaging viral-ready clips.",
  },
  {
    question: "Where should I post my clips?",
    answer:
      "We recommend posting your clips to TikTok and YouTube. However, you can also post to Instagram and other platforms.",
  },
  {
    question: "How do I get started?",
    answer:
      "Simply click on the button below to start creating viral content that reaches millions.",
  },
] as const;

export const ChatFAQSection: React.FC<ChatFAQSectionProps> = ({
  onStartClipping,
}) => (
  <section
    id="faq"
    className="bg-white px-5 py-20 sm:px-6 sm:py-28 lg:px-8"
    aria-labelledby="faq-heading"
  >
    <div className="mx-auto max-w-4xl">
      <h2
        id="faq-heading"
        className="tc-section-title text-center text-[var(--tc-ink)]"
      >
        Frequently asked questions
      </h2>

      <div data-faq-chat className="mt-12 space-y-8">
        {questions.map((item) => (
          <article key={item.question} className="space-y-3">
            <div className="flex justify-end">
              <p className="max-w-[88%] rounded-2xl rounded-br-sm bg-[var(--tc-blue)] px-5 py-3 font-bold text-white shadow-md sm:max-w-xl sm:text-lg">
                {item.question}
              </p>
            </div>
            <div className="flex items-end gap-3">
              <div className="grid h-10 w-10 flex-none place-items-center rounded-full border border-slate-200 bg-white shadow-sm">
                <img
                  src="/final-icon.png"
                  alt=""
                  aria-hidden="true"
                  className="h-6 w-6 object-contain"
                />
              </div>
              <p className="max-w-[calc(100%-3.25rem)] rounded-2xl rounded-bl-sm border border-slate-200 bg-slate-50 px-5 py-4 leading-7 text-slate-700 shadow-sm sm:max-w-2xl sm:text-lg">
                {item.answer}
              </p>
            </div>
          </article>
        ))}
      </div>

      <FAQSection />

      <div className="mt-14 text-center">
        <button
          type="button"
          onClick={() => void onStartClipping()}
          className="tc-primary-action inline-flex min-h-14 items-center justify-center gap-2 rounded-full bg-[var(--tc-blue)] px-9 text-lg font-bold text-white shadow-[var(--tc-shadow-cta)] transition hover:-translate-y-0.5 hover:bg-[var(--tc-blue-hover)] hover:shadow-[0_18px_38px_rgba(22,119,255,0.34)]"
        >
          Try TopClip Now
          <ArrowRight aria-hidden="true" className="h-6 w-6" />
        </button>
      </div>
    </div>
  </section>
);
